// Credentials are rejected so "mailto:a@b.de" with a prepended https:// cannot slip through as user@host.
const isWebUrl = (url) =>
	(url.protocol === 'http:' || url.protocol === 'https:') && url.hostname.includes('.') && !url.username;

/**
 * Validates and normalizes a URL input. Only http(s) URLs with a dotted host pass; input without
 * a scheme gets 'https://' prepended. Empty input is valid (optional field).
 *
 * @param {string|null|undefined} value
 * @returns {{valid: boolean, normalized: string|null, error: string|null}} `normalized` is null for
 *   empty or invalid input.
 */
export function validateUrl(value) {
	if (!value || !value.trim()) return { valid: true, normalized: null, error: null };
	const trimmed = value.trim();
	const candidate = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

	try {
		if (isWebUrl(new URL(candidate))) return { valid: true, normalized: candidate, error: null };
	} catch {
		// Not parseable as a URL; falls through to the error result.
	}

	return {
		valid: false,
		normalized: null,
		error: 'Bitte eine gültige URL eingeben (z. B. https://example.com)',
	};
}
